module.exports = __webpack_public_path__ + "static/img/news-top.2fd7eaba.png";